import { render } from "./ChipDistributionAnalysis.vue?vue&type=template&id=65e0917a&scoped=true&ts=true"
import script from "./ChipDistributionAnalysis.vue?vue&type=script&lang=ts"
export * from "./ChipDistributionAnalysis.vue?vue&type=script&lang=ts"

import "./ChipDistributionAnalysis.vue?vue&type=style&index=0&id=65e0917a&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e0917a"]])

export default __exports__